import { fromPairs, range } from 'lodash';

/**
 * adapted from https://codepen.io/tigt/post/optimizing-svgs-in-data-uris
 */
export function prepareSVGAsDataURI(rawSVG) {
    const prefix = 'data:image/svg+xml,';
    let svg = encodeURIComponent(rawSVG.replace(/\n+/g, ''));

    // restore ASCII-safe characters
    svg = svg.replace(/%20/g, ' '); // spaces
    svg = svg.replace(/%3D/g, '='); // equal signs
    svg = svg.replace(/%3A/g, ':'); // colons
    svg = svg.replace(/%2F/g, '/'); // slashes

    // replace quotes with apostrophes (may break certain SVGs)
    // this allows the consumer to safely encase the data URI string in double quotes as we do in JSX templates, etc.
    svg = svg.replace(/%22/g, "'");

    return `${prefix}${svg}`;
}

export const getLogo = theme => theme.header.logo;

export const sitemapRoutes = directoryId => {
    return fromPairs(
        range(0, 10).map(index => [
            `/${index}.0.3249080598340583490835904589.xml`,
            `https://d1zxd2hoqiq9gs.cloudfront.net/public/providers/v2/latest/${directoryId}/${index}.0.xml`,
        ])
    );
};
